module.exports = __webpack_public_path__ + "img/rating.5d561475.svg";